<template>
	<div class="partial partial--board-command board-command">
		<div class="board-command__heading">
			<form class="form" method="get" v-if="isSsb">
				<autocomplete-organization v-model="orgId" @original="orgSelect" :required="false" class="" />
			</form>
			<p>Something off? <router-link :to="{name: 'boardsupport'}">Submit Support Request</router-link></p>
		</div>
		<iframe :src="iframeSrc" />

		<modal @close="hideModal" :open="modalVisible" :title="modalTitle">
			<router-view class="main__modal" slot="content" name="pageModal" />
		</modal>
	</div>
</template>

<script>
import AButton from '@/components/AButton'
import AutocompleteOrganization from '@/components/AutocompleteOrganization'
import Modal from '@/components/Modal'
import TextField from '@/components/TextField'


export default {
	name: 'BoardCommandPartial',
	components: {
		AButton,
		AutocompleteOrganization,
		Modal,
		TextField,
	},
	metaInfo: () => ({
		title: 'BoardCommand',
	}),
	mounted() {
		this.trackVisit()
	},
	data: () => ({
		orgId : null,
	}),
	computed: {
		isSsb() {
			const me = this.$store.getters['user/me']
			return me.organization?.settings?.entity
		},
		snlNumber() {
			const me = this.$store.getters['user/me']
			return this.isSsb && this.$route.query?.snl ? this.$route.query?.snl : me.organization?.settings?.snlNumber
		},
		email() {
			const me = this.$store.getters['user/me']
			return me.email
		},
		iframeSrc() {
			return `https://boardcommand.statumkpi.app/?snl=${this.snlNumber}&email=${this.email}`
		},
		modalVisible() {
			return this.$route.name == 'boardsupport'
		},
		modalTitle() {
			return this.$route.meta.modalTitle
		},
	},
	methods: {
		orgSelect(org) {
			if (org.settings?.snlNumber) {
				this.$router.push({name: 'boardcommand', query: { snl: org.settings?.snlNumber}})
			}
		},
		trackVisit() {
			const track = {
				event_name: 'access',
				app: 'board-command',
			}
			this.$store.dispatch(`user/trackMe`, track)
		},
		requestSnl() {
			this.$store.dispatch(`user/snlRequest`)
				.then(() => {
					this.$notice(`Thanks for submitting your access request. Our team is reviewing it now. We’ll contact you when your institution is approved or if we need more details.`)
				}).catch(error => {
					this.error = error
					this.$notice(`ERROR: ${error.message || error}`)
				})

		},
		hideModal(clicked) {
			this.$router.replace({ name: 'boardcommand' })
		},
	},
}
</script>

<style scoped lang="scss">
iframe {
	border: 0;
	height: 100%;
	width: 100%;
}

.board-command {
	&__heading {
		background-color: modules.color_('background','medium');
		border-bottom: 1px solid modules.color_('border');
		display: flex;
		padding: 0.15rem 1.5rem;
		flex-direction: row;
		justify-content: space-between;

		> :last-child {
			margin-left: auto;
		}
	}
}
</style>
